// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fSlS0veNBl {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.fSlS0veNBl h4 {
  line-height: 3em;
}
.fSlS0veNBl .fBjJSZZsMt {
  float: left;
  width: 100%;
}
.fSlS0veNBl .T_ysRz953s {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.fSlS0veNBl .T_ysRz953s:hover {
  cursor: pointer;
}
.fSlS0veNBl .T_ysRz953s:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.IQUs0a47J0 .INi0s_2mbE:focus {
  outline: none;
}
.IQUs0a47J0 .INi0s_2mbE.E2gqt0E0oE.y0_5eAFrzT {
  background: #375A88;
}
.IQUs0a47J0 .INi0s_2mbE.E2gqt0E0oE.y0_5eAFrzT span {
  color: #fff;
}
.IQUs0a47J0 .y0_5eAFrzT {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.IQUs0a47J0 .y0_5eAFrzT:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.IQUs0a47J0 input {
  height: 38px;
  min-width: 220px;
}
.T_ysRz953s.ShgwKpVxDb {
  background: #410102;
}
.T_ysRz953s.DJ9HGr5j5m {
  background: #911318;
}
.T_ysRz953s.ufpe6mcJ8P {
  background: #D8293B;
}
.T_ysRz953s.Yq2SaIiMSl {
  background: #F2373C;
}
.T_ysRz953s.fp_pJzbtPQ {
  background: #FC4448;
}
.T_ysRz953s.Mx7uJh09Df {
  background: #ED535E;
}
.T_ysRz953s.d0SDkFw3fK {
  background: #E34926;
}
.T_ysRz953s.m1r7DUbXkP {
  background: #FC562B;
}
.T_ysRz953s.F35_iiXLbX {
  background: #FC6722;
}
.T_ysRz953s.lKcJQIdaoP {
  background: #FD7F24;
}
.T_ysRz953s.wYTjqwkbUy {
  background: #FD8D26;
}
.T_ysRz953s.hGggCMZM5Y {
  background: #EC9C3E;
}
.T_ysRz953s.MYX9oCHosm {
  background: #0e673a;
}
.T_ysRz953s.uX3FgzWM5_ {
  background: #208740;
}
.T_ysRz953s.s9Cewo1pri {
  background: #239718;
}
.T_ysRz953s.p4lxXRbv3D {
  background: #55A84D;
}
.T_ysRz953s.iDMCZMnkyp {
  background: #4BBE5A;
}
.T_ysRz953s.BzpyABqSyh {
  background: #0CCA6A;
}
.T_ysRz953s.yWAvNAo6Yp {
  background: #0A3C64;
}
.T_ysRz953s.J3tUID_Y64 {
  background: #0d487a;
}
.T_ysRz953s.r44Bu1qHSl {
  background: #10538d;
}
.T_ysRz953s.lgx8PnNwrv {
  background: #115A99;
}
.T_ysRz953s.S7flDc1AY8 {
  background: #3387E2;
}
.T_ysRz953s.V5VeOZmvR8 {
  background: #1BA9CF;
}
.T_ysRz953s.rNQ2W4dMjA {
  background: #d27c02;
}
.T_ysRz953s.P0YT18VQpS {
  background: #fb9402;
}
.T_ysRz953s.I8TtkcaYN3 {
  background: #FD9B30;
}
.T_ysRz953s.J0LYWpEc45 {
  background: #FDBE2D;
}
.T_ysRz953s.fGPQVAyzvh {
  background: #FED831;
}
.T_ysRz953s.MmLHlSt_Hn {
  background: #FFFD38;
}
.T_ysRz953s.fBO3goNJOy {
  background: #2D215C;
}
.T_ysRz953s.sE_eIL2HZ4 {
  background: #483C83;
}
.T_ysRz953s.XZJe_pMoPL {
  background: #58518d;
}
.T_ysRz953s.MQ2s4EFKGW {
  background: #7068A9;
}
.T_ysRz953s._mnD0HQLyq {
  background: #7f78b2;
}
.T_ysRz953s.HDiU1yGpms {
  background: #8f88bc;
}
.T_ysRz953s.ORHW4X6kMZ {
  background: #000;
}
.T_ysRz953s.Klm8_OS4bc {
  background: #282626;
}
.T_ysRz953s.Ddjih4LzMc {
  background: #242222;
}
.T_ysRz953s.iEM40awpW_ {
  background: #353838;
}
.T_ysRz953s.tJMg799_SO {
  background: #666;
}
.T_ysRz953s.iEKscQpZD4 {
  background: #999;
}
.mFUdPBJwmu {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.mFUdPBJwmu .GgLmqJrWph {
  display: none;
}
/* Gray (neutral) */
.bSuJiG43Z9 {
  display: flex;
  align-items: center;
}
.AnsnayyJTo {
  padding: 16px;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.AnsnayyJTo .UG_Qg4QNgR {
  border: 1px solid #E4E4E6 !important;
}
.OEZfgNlKYv {
  padding: 8px 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  height: 32px;
}
.RaEr6qD5R_ {
  border: 1px solid #cac9cc;
  border-radius: 40px;
  padding: 2px 8px;
  font-size: 11px;
}
.YZb42kL7Op {
  font-size: 13px;
}
.OEZfgNlKYv:hover {
  background: #F2F2F2;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `fSlS0veNBl`,
	"color-row": `fBjJSZZsMt`,
	"color-tile": `T_ysRz953s`,
	"picker-component": `IQUs0a47J0`,
	"picker-element": `INi0s_2mbE`,
	"active": `E2gqt0E0oE`,
	"btn": `y0_5eAFrzT`,
	"red-1": `ShgwKpVxDb`,
	"red-2": `DJ9HGr5j5m`,
	"red-3": `ufpe6mcJ8P`,
	"red-4": `Yq2SaIiMSl`,
	"red-5": `fp_pJzbtPQ`,
	"red-6": `Mx7uJh09Df`,
	"orange-1": `d0SDkFw3fK`,
	"orange-2": `m1r7DUbXkP`,
	"orange-3": `F35_iiXLbX`,
	"orange-4": `lKcJQIdaoP`,
	"orange-5": `wYTjqwkbUy`,
	"orange-6": `hGggCMZM5Y`,
	"green-1": `MYX9oCHosm`,
	"green-2": `uX3FgzWM5_`,
	"green-3": `s9Cewo1pri`,
	"green-4": `p4lxXRbv3D`,
	"green-5": `iDMCZMnkyp`,
	"green-6": `BzpyABqSyh`,
	"blue-1": `yWAvNAo6Yp`,
	"blue-2": `J3tUID_Y64`,
	"blue-3": `r44Bu1qHSl`,
	"blue-4": `lgx8PnNwrv`,
	"blue-5": `S7flDc1AY8`,
	"blue-6": `V5VeOZmvR8`,
	"yellow-1": `rNQ2W4dMjA`,
	"yellow-2": `P0YT18VQpS`,
	"yellow-3": `I8TtkcaYN3`,
	"yellow-4": `J0LYWpEc45`,
	"yellow-5": `fGPQVAyzvh`,
	"yellow-6": `MmLHlSt_Hn`,
	"purple-1": `fBO3goNJOy`,
	"purple-2": `sE_eIL2HZ4`,
	"purple-3": `XZJe_pMoPL`,
	"purple-4": `MQ2s4EFKGW`,
	"purple-5": `_mnD0HQLyq`,
	"purple-6": `HDiU1yGpms`,
	"black-1": `ORHW4X6kMZ`,
	"black-2": `Klm8_OS4bc`,
	"black-3": `Ddjih4LzMc`,
	"black-4": `iEM40awpW_`,
	"black-5": `tJMg799_SO`,
	"black-6": `iEKscQpZD4`,
	"picker-theme": `mFUdPBJwmu`,
	"arrow-regular": `GgLmqJrWph`,
	"trigger-state-modal--header": `bSuJiG43Z9`,
	"stage-select__container": `AnsnayyJTo`,
	"stage-select__menu-list": `UG_Qg4QNgR`,
	"stage-select__option": `OEZfgNlKYv`,
	"stage-select__option--index": `RaEr6qD5R_`,
	"stage-select__option--label": `YZb42kL7Op`
};
export default ___CSS_LOADER_EXPORT___;
